// API-path-shaped TanStack Query keys. Sub-keys nest as arrays under the
// parent string (e.g. [EVENTS_ACTIVE_KEY, 'x']) so `invalidateQueries`
// with the parent key reaches every derived query by prefix match. Mirrors
// the convention in `files-viewer/src/hooks/queryKeys.ts`.
export const EVENTS_ACTIVE_KEY = 'v2/events/active';
